import { combineCls, rotate, twCls } from 'style';
import { IconProps } from './IconProps';

export type ArrowIconProps = IconProps & {
  direction?: 'up' | 'down';
};

export const ArrowIcon = ({
  className,
  direction = 'down',
  width = 11,
  height = 17,
}: ArrowIconProps) => (
  <svg
    className={combineCls(twCls(rotate(direction === 'up' ? 'rotate-180' : 'rotate-0')), className)}
    width={width}
    height={height}
    viewBox="0 0 11 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#727272" fillRule="evenodd">
      <path d="M5.5 16.5 0 7.611h11z" />
      <path d="M6.769 8.5H4.231v-8h2.538z" />
    </g>
  </svg>
);
